import { render, staticRenderFns } from "./ModalListSiblings.vue?vue&type=template&id=4e4c8fce&scoped=true"
import script from "./ModalListSiblings.vue?vue&type=script&lang=js"
export * from "./ModalListSiblings.vue?vue&type=script&lang=js"
import style0 from "./ModalListSiblings.vue?vue&type=style&index=0&id=4e4c8fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c8fce",
  null
  
)

export default component.exports